module.exports = __webpack_public_path__ + "img/Reset-Looc_pairing.3c5f1deb.png";